import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Home';

const Home = () => ((orgContainer(InnerComponent)));

export default Home;
